import { useWorkflowContext } from "@/pages/workflow/context/WorkflowContext";
import {
  Button,
  ButtonGroup,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useGetVault } from "@equidefi/portals/hooks/useVault";
import { Heading } from "@equidefi/ui";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const WorkflowProtection = ({ vaultId }) => {
  const { investment, offering, refetchInvestment } = useWorkflowContext();
  const navigate = useNavigate();
  const { data: vault } = useGetVault(vaultId);

  if (!vault?.inquiry_id) {
    return null;
  }

  useEffect(() => {
    refetchInvestment();
  }, []);

  return (
    <Flex
      position="absolute"
      width="100%"
      height="100%"
      top="0"
      left="0"
      backgroundColor="#00000050"
      zIndex={1000}>
      <Modal
        isOpen={true}
        onClose={() => {
          // do nothing, this locks the page
        }}
        aria-labelledby="contained-modal-title-vcenter"
        motionPreset="slideInBottom">
        <ModalOverlay pt="50%" />

        <ModalContent mx="4">
          <ModalHeader>
            <Heading fontWeight="bold" mb="0">
              Warning!
            </Heading>
            <ModalCloseButton color="equidefi.red" />
          </ModalHeader>

          <ModalBody>
            <Text>
              You cannot make changes to your investment after identity
              verification has begun. If you need to make a change, please
              contact support. Otherwise, click Continue to resume your
              investment process.
            </Text>
          </ModalBody>

          <ModalFooter>
            <ButtonGroup>
              <Button
                colorScheme="purple"
                onClick={() => {
                  refetchInvestment().then(() => {
                    navigate(
                      `/offerings/${offering.slug}/${investment.id}/${investment.next.toLowerCase()}`,
                    );
                  });
                }}>
                Continue
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  navigate("/support");
                }}>
                Contact Support
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default WorkflowProtection;
